// JsFromRoutes CacheKey a16cfed9a0d6f0e5728ae8bf9ff1a66c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  approve: /* #__PURE__ */ definePathHelper('post', '/admin/invoice_item_review/:invoice_item_review_id/approve'),
  blockProcessing: /* #__PURE__ */ definePathHelper('post', '/admin/invoice_item_review/:invoice_item_review_id/block_processing'),
  createNote: /* #__PURE__ */ definePathHelper('post', '/admin/invoice_item_review/:invoice_item_review_id/create_note'),
  markAsLoss: /* #__PURE__ */ definePathHelper('post', '/admin/invoice_item_review/:invoice_item_review_id/mark_as_loss'),
  reconcileRefund: /* #__PURE__ */ definePathHelper('post', '/admin/invoice_item_review/:invoice_item_review_id/reconcile_refund'),
  removeLoss: /* #__PURE__ */ definePathHelper('post', '/admin/invoice_item_review/:invoice_item_review_id/remove_loss'),
  unblockProcessing: /* #__PURE__ */ definePathHelper('post', '/admin/invoice_item_review/:invoice_item_review_id/unblock_processing'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/invoice_item_review'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/invoice_item_review/:id'),
}
